import { render, staticRenderFns } from "./SalesByTerritory.vue?vue&type=template&id=d4d8073a"
import script from "./SalesByTerritory.vue?vue&type=script&lang=js"
export * from "./SalesByTerritory.vue?vue&type=script&lang=js"
import style0 from "./SalesByTerritory.vue?vue&type=style&index=0&id=d4d8073a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports